<template>
    <el-dialog
        width="500px"
        title="修改Acos"
        :visible.sync="visible"
        :before-close="handleClose"
        top="5vh"
        append-to-body
    >
        <el-form ref="formData" :model="formData" :rules="rules" size="mini" label-width="130px"  :inline="true">
            <el-form-item label="Acos：">
                <el-input-number v-model="formData.set_profit_rate_no_tax" style="width: 200px;margin-right:20px;" size="mini"
                          placeholder="请输入Acos" :min="0" :max="300" :step="0.01"></el-input-number>
            </el-form-item>
            <div style="height: 30px; line-height: 30px; margin-left: -10px; display: inline-block;">%</div>
        </el-form>

        <el-row style="margin-top:17px; ">
            <el-button style="float:right;margin-left:6px;" size="mini" type="danger" plain @click="handleClose()">关 闭
            </el-button>
            <el-button style="float:right" size="mini" type="success" @click="submitForm(true)" :loading="loading">使用系统值
            </el-button>
            <el-button style="float:right" size="mini" type="primary" @click="submitForm()" :loading="loading">修 改
            </el-button>
        </el-row>
    </el-dialog>
</template>

<script>
    import * as api from '@/api/advAnalys/advAnalys.js'

    export default {
        name: 'updatePatent',
        data() {
            return {
                visible: false,
                loading: false,
                formData: {},
                rules: {},

                fileList: [],
                obj: {},
                disabled: false,
                filesize: 0,
                value: '',
                file_data: null
            }
        },
        methods: {

            openModal(data) {
                const tempData = JSON.parse(JSON.stringify(data))
                if(tempData.set_profit_rate_no_tax !== null) {
                    tempData.set_profit_rate_no_tax = tempData.set_profit_rate_no_tax * 100
                }
                this.formData = tempData
                this.visible = true
            },
            submitForm(flag) {
                this.loading = true
                let num = this.formData.set_profit_rate_no_tax
                if(flag) {
                    num = "default"
                } else if(this.formData.set_profit_rate_no_tax !== null) {
                    num = this.formData.set_profit_rate_no_tax / 100
                }
                api.operating_asin_manager_index_update_field({
                    id: this.formData.id,
                    set_profit_rate_no_tax: num,
                }).then(res => {
                    this.loading = false
                    if (res.code === 0) {
                        this.$message({message: '修改成功', type: 'success'})
                        this.handleClose(true)
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(() => {
                    this.loading = false
                    this.$message({type: 'error', message: '网络出现问题，请刷新页面！'})
                })
            },

            // 关闭弹窗
            handleClose(isshow = false) {
                this.visible = false
                this.$emit('close-callback', isshow)
            }
        }
    }
</script>

